export default __webpack_public_path__ + "static/media/score-javelin.90b3e9ab.png";